export const CREATE_USAGE_HISTORY = "CREATE_USAGE_HISTORY";
export const FETCH_USAGE_HISTORIES = "FETCH_USAGE_HISTORIES";
export const FETCH_USAGE_HISTORY = "FETCH_USAGE_HISTORY";
export const EDIT_USAGE_HISTORY = "EDIT_USAGE_HISTORY";
export const DELETE_USAGE_HISTORY = "DELETE_USAGE_HISTORY";
